import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import Dialog from './Dialog';
import {clearNetworkError} from '../../app/actions';

// A modal dialog for recoverable network errors (timeouts, disconnects).
// Unlike FatalErrorDialog, dismissing this does NOT refresh the page -
// the user can simply close it and retry the action that failed.
const NetworkErrorDialog = ({message, onDismiss}) => {
  return (
    <Dialog
      confirmLabel="OK"
      title="Connection problem"
      onConfirm={onDismiss}
      showCancel={false}
      onDismiss={onDismiss}>
      <p dangerouslySetInnerHTML={{__html: message}} />
    </Dialog>
  );
};
NetworkErrorDialog.propTypes = {
  message: PropTypes.string.isRequired,
  onDismiss: PropTypes.func.isRequired
};

export default connect(
  null,
  {onDismiss: clearNetworkError}
)(NetworkErrorDialog);
